export default "__VITE_ASSET__6c1c1017__"